import React, { useState, useEffect } from "react";
import { Form, Button, Container, Row, Col } from "react-bootstrap";
import axios from "axios";
import Swal from "sweetalert2";
import Layout from "../../../layout/default";
import { useNavigate, useLocation } from "react-router-dom";
import { useParams } from "react-router-dom"; // Import useParams to access URL params


const MultiPart = () => {
    const navigate = useNavigate();
    const location = useLocation(); // To access state passed via navigate
    console.log(location.state); // Check if state is being passe
    const { comboId, comboName, image, price } = location.state || {}; // Destructure combo data from state
    const [step, setStep] = useState(1);
    const [formData, setFormData] = useState({
        name: "",
        lastName: "",
        middle_name: "",
        aadhar_number: "",
        pancard_number: "",
        password: "",
        phone_number: "",
        phone_2: "",
        alt_phone: "",
        email: "",
        transaction_id: "",
        parent_id: "",
        leg: "",
        state_id: "",
        district_id: "",
        city_id: "",
        pincode: "",
        zone: "",
        address: "",
        combo_id: comboId, // Set comboId from URL
    });

    const [states, setStates] = useState([]);
    const [districts, setDistricts] = useState([]);
    const [cities, setCities] = useState([]);
    const [zones, setZones] = useState([]);
    const handleSubmit = async (e) => {
        e.preventDefault();

        // Phone Number Validation (must be 10 digits)
        if (!/^\d{10}$/.test(formData.phone_number)) {
            Swal.fire({
                icon: 'error',
                title: 'Invalid Input',
                text: 'Primary phone number must be exactly 10 digits.',
            });
            return;
        }

        // Aadhar Number Validation (must be 12 digits)
        if (!/^\d{12}$/.test(formData.aadhar_number)) {
            Swal.fire({
                icon: 'error',
                title: 'Invalid Input',
                text: 'Aadhar number must be exactly 12 digits.',
            });
            return;
        }

        // PAN Card Validation (must be 8 characters alphanumeric)
        if (!/^[A-Z]{5}\d{4}[A-Z]{1}$/.test(formData.pancard_number)) {
            Swal.fire({
                icon: 'error',
                title: 'Invalid Input',
                text: 'PAN card number must be in a valid format (5 letters, 4 digits, and 1 letter). Example: ABCDE1234F.',
            });
            return;
        }


        // Email Validation (must be in a valid email format)
        if (!/\S+@\S+\.\S+/.test(formData.email)) {
            Swal.fire({
                icon: 'error',
                title: 'Invalid Input',
                text: 'Please enter a valid email address.',
            });
            return;
        }

        // Password Validation (minimum 6 characters)
        if (formData.password.length < 6) {
            Swal.fire({
                icon: 'error',
                title: 'Invalid Input',
                text: 'Password must be at least 6 characters long.',
            });
            return;
        }

        // Confirm Password Validation (must match password)
        if (formData.password !== formData.confirm_password) {
            Swal.fire({
                icon: 'error',
                title: 'Invalid Input',
                text: 'Password and Confirm Password must match.',
            });
            return;
        }

        // Validate Pincode (6 digits)
        if (!/^\d{6}$/.test(formData.pincode)) {
            Swal.fire({
                icon: 'error',
                title: 'Invalid Input',
                text: 'Pincode must be a valid 6-digit number.',
            });
            return;
        }


        try {
            const response = await axios.post(`${process.env.REACT_APP_HOST}api/register/distributor`, formData, {
                headers: {
                    "Content-Type": "application/json",
                },
            });
            Swal.fire("Success!", "Registration successful!", "success");
            navigate("/shop");
        } catch (error) {
            // Default error message
            let errorMessage = "Registration failed. Please try again.";

            // Check for specific error messages in the response
            if (error.response && error.response.data) {
                // Handle Duplicate Email Error
                debugger;
                if (error.response.data.errors === 'Email already exists.') {
                    errorMessage = 'The email address is already registered. Please use a different email.';
                }
                // Handle Duplicate Aadhaar Error
                else if (error.response.data.errors === 'Aadhar number already exists.') {
                    errorMessage = 'The Aadhaar number is already registered. Please use a different Aadhaar number.';
                } else {
                    // If there are any other errors, use the backend's message
                    errorMessage = error.response.data.errors || errorMessage;

                    // Optionally handle validation errors
                    if (error.response.data.errors) {
                        const validationErrors = Object.values(error.response.data.errors).flat().join(' ');
                        errorMessage = validationErrors;
                    }
                }
            }

            // Show the error message using SweetAlert
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: errorMessage,
            });
        }
    };


    useEffect(() => {
        // Update the combo_id and amount in the formData whenever comboId or price changes
        setFormData((prevState) => ({
            ...prevState,
            combo_id: comboId,
            amount: String(price), // Ensure price is converted to a string
        }));
    }, [comboId, price]); // Both comboId and price should be in the dependency array

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_HOST}api/states`)
            .then(response => setStates(response.data))
            .catch(error => Swal.fire("Error!", "Failed to fetch states.", "error"));
    }, []);

    useEffect(() => {
        if (formData.state_id) {
            axios.get(`${process.env.REACT_APP_HOST}api/state_districts?state_id=${formData.state_id}`)
                .then(response => {
                    if (response.data && Array.isArray(response.data.data)) {
                        setDistricts(response.data.data);
                    } else {
                        setDistricts([]); // Ensure it's always an array
                    }
                })
                .catch(error => Swal.fire("Error!", "Failed to fetch districts.", "error"));
        } else {
            setDistricts([]); // Reset districts if state is not selected
        }
    }, [formData.state_id]);

    useEffect(() => {
        if (formData.district_id) {
            axios.get(`${process.env.REACT_APP_HOST}api/district_cities?district_id=${formData.district_id}`)
                .then(response => {
                    if (response.data && Array.isArray(response.data.data)) {
                        setCities(response.data.data);
                    } else {
                        setCities([]); // Ensure it's always an array
                    }
                })
                .catch(error => Swal.fire("Error!", "Failed to fetch cities.", "error"));
        } else {
            setCities([]); // Reset cities if district is not selected
        }
    }, [formData.district_id]);

    useEffect(() => {
        if (formData.city_id) {
            axios.get(`${process.env.REACT_APP_HOST}api/city_zones?city_id=${formData.city_id}`)
                .then(response => {
                    if (response.data && Array.isArray(response.data.data)) {
                        setZones(response.data.data);
                    } else {
                        setZones([]); // Ensure it's always an array
                    }
                })
                .catch(error => Swal.fire("Error!", "Failed to fetch zones.", "error"));
        } else {
            setZones([]); // Reset zones if city is not selected
        }
    }, [formData.city_id]);


    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const nextStep = () => setStep(step + 1);
    const prevStep = () => setStep(step - 1);

    return (
        <Layout title="Distributor Registration">
            <Container className="mt-4">
                <Row className="justify-content-md-center">
                    <Col md={8}>
                        <h3>Distributor Registration (Step {step}/4)</h3>
                        <Form>
                            {step === 1 && (
                                <>
                                    <Form.Group>
                                        <Form.Label>First Name</Form.Label>
                                        <Form.Control type="text" name="name" value={formData.name} onChange={handleChange} required />
                                    </Form.Group>
                                    <Form.Group>
                                        <Form.Label>Last Name</Form.Label>
                                        <Form.Control type="text" name="lastName" value={formData.lastName} onChange={handleChange} required />
                                    </Form.Group>
                                    <Form.Group>
                                        <Form.Label>Middle Name (Optional)</Form.Label>
                                        <Form.Control type="text" name="middle_name" value={formData.middle_name} onChange={handleChange} />
                                    </Form.Group>
                                    <Form.Group>
                                        <Form.Label>Password</Form.Label>
                                        <Form.Control type="password" name="password" value={formData.password} onChange={handleChange} required />
                                    </Form.Group>
                                    <Form.Group>
                                        <Form.Label>Confirm Password</Form.Label>
                                        <Form.Control type="password" name="confirm_password" value={formData.confirm_password} onChange={handleChange} required />
                                    </Form.Group>
                                    <Button variant="primary" onClick={nextStep} className="mt-3">Next</Button>
                                </>
                            )}

                            {step === 2 && (
                                <>
                                    <Form.Group>
                                        <Form.Label>Aadhar Number</Form.Label>
                                        <Form.Control type="text" name="aadhar_number" value={formData.aadhar_number} onChange={handleChange} required />
                                    </Form.Group>
                                    <Form.Group>
                                        <Form.Label>PAN Card Number</Form.Label>
                                        <Form.Control type="text" name="pancard_number" value={formData.pancard_number} onChange={handleChange} required />
                                    </Form.Group>
                                    <Form.Group>
                                        <Form.Label>Phone Number</Form.Label>
                                        <Form.Control type="text" name="phone_number" value={formData.phone_number} onChange={handleChange} required />
                                    </Form.Group>
                                    <Form.Group>
                                        <Form.Label>Phone Number(Optional)</Form.Label>
                                        <Form.Control type="text" name="phone_2" value={formData.phone_2} onChange={handleChange} required />
                                    </Form.Group>
                                    <Button variant="secondary" onClick={prevStep} className="mt-3">Previous</Button>
                                    <Button variant="primary" onClick={nextStep} className="mt-3 ms-2">Next</Button>
                                </>
                            )}

                            {step === 3 && (
                                <>
                                    <Form.Group>
                                        <Form.Label>State</Form.Label>
                                        <Form.Select name="state_id" value={formData.state_id} onChange={handleChange} required>
                                            <option value="">Select State</option>
                                            {states.map(state => (
                                                <option key={state.id} value={state.id}>{state.name}</option>
                                            ))}
                                        </Form.Select>
                                    </Form.Group>
                                    <Form.Group>
                                        <Form.Label>District</Form.Label>
                                        <Form.Select name="district_id" value={formData.district_id} onChange={handleChange} required>
                                            <option value="">Select District</option>
                                            {districts.map(district => (
                                                <option key={district.id} value={district.id}>{district.name}</option>
                                            ))}
                                        </Form.Select>
                                    </Form.Group>
                                    <Form.Group>
                                        <Form.Label>City</Form.Label>
                                        <Form.Select name="city_id" value={formData.city_id} onChange={handleChange} required>
                                            <option value="">Select City</option>
                                            {cities.map(city => (
                                                <option key={city.id} value={city.id}>{city.name}</option>
                                            ))}
                                        </Form.Select>
                                    </Form.Group>
                                    <Form.Group>
                                        <Form.Label>Zone</Form.Label>
                                        <Form.Select name="zone_id" value={formData.zone_id} onChange={handleChange} required>
                                            <option value="">Select Zone</option>
                                            {zones.map(zone => (
                                                <option key={zone.id} value={zone.id}>{zone.name}</option>
                                            ))}
                                        </Form.Select>
                                    </Form.Group>
                                    <Button variant="secondary" onClick={prevStep} className="mt-3">Previous</Button>
                                    <Button variant="primary" onClick={nextStep} className="mt-3 ms-2">Next</Button>
                                </>
                            )}

                            {step === 4 && (
                                <>
                                    <Form.Group>
                                        <Form.Label>Address</Form.Label>
                                        <Form.Control type="text" name="address" value={formData.address} onChange={handleChange} required />
                                        <Form.Label>Email</Form.Label>
                                        <Form.Control type="text" name="email" value={formData.email} onChange={handleChange} required />
                                        <Form.Label>Transaction ID</Form.Label>
                                        <Form.Control type="text" name="transaction_id" value={formData.transaction_id} onChange={handleChange} required />
                                        <Form.Label>parent ID</Form.Label>
                                        <Form.Control type="text" name="parent_id" value={formData.parent_id} onChange={handleChange} required />
                                        <Form.Label>Leg</Form.Label>
                                        <Form.Control type="text" name="leg" value={formData.leg} onChange={handleChange} required />
                                        <Form.Label>Pincode</Form.Label>
                                        <Form.Control type="text" name="pincode" value={formData.pincode} onChange={handleChange} required />
                                        <Form.Group>
                                            <Form.Label>Combo ID</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="combo_id"
                                                value={formData.combo_id || ""}
                                                readOnly
                                            />
                                        </Form.Group>
                                        <Form.Group>
                                            <Form.Label>Combo Name</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="combo_name"
                                                value={comboName || ""}
                                                readOnly
                                            />
                                        </Form.Group>
                                        <Form.Group>
                                            <Form.Label>Combo Price</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="price"
                                                value={price || ""}
                                                readOnly
                                            />
                                        </Form.Group>
                                        <Form.Group>
                                            <Form.Label>Combo Image</Form.Label>
                                            <img
                                                src={`${image}` || '/path/to/default-image.jpg'}
                                            />
                                        </Form.Group>
                                    </Form.Group>
                                    <div className="text-center">
                                        <Button
                                            variant="secondary"
                                            onClick={() => navigate('/shop')}
                                            className="mt-3"
                                        >
                                            Do you want to change Combo?
                                        </Button>
                                    </div>
                                    <Button variant="secondary" onClick={prevStep} className="mt-3">Previous</Button>
                                    <Button variant="success" className="mt-3 ms-2" onClick={handleSubmit}>Submit</Button>
                                </>
                            )}
                        </Form>
                    </Col>
                </Row>
            </Container>
            <br />
            <br />
            <br />
            <br />
        </Layout>
    );
};

export default MultiPart;
